import g00 from '../../../assets/images/main/main_g01.jpg'
import g01 from '../../../assets/images/main/main_g02.jpg'
import g02 from '../../../assets/images/main/main_g03.jpg'
import g03 from '../../../assets/images/main/main_g04.jpg'
import g04 from '../../../assets/images/main/main_g05.jpg'
import g05 from '../../../assets/images/main/main_g06.jpg'
import g00_webp from '../../../assets/images/main/main_g01.webp'
import g01_webp from '../../../assets/images/main/main_g02.webp'
import g02_webp from '../../../assets/images/main/main_g03.webp'
import g03_webp from '../../../assets/images/main/main_g04.webp'
import g04_webp from '../../../assets/images/main/main_g05.webp'
import g05_webp from '../../../assets/images/main/main_g06.webp'


export const outerDesignData = [
    {
        itemClassName: "cont1 type1",
        src: g00, 
        webp: g00_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
    {
        itemClassName: "cont1 type1",
        src: g01, 
        webp: g01_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
    {
        itemClassName: "cont1 type1",
        src: g02, 
        webp: g02_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
    {
        itemClassName: "cont1 type1",
        src: g03, 
        webp: g03_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
    {
        itemClassName: "cont1 type1",
        src: g04, 
        webp: g04_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
    {
        itemClassName: "cont1 type1",
        src: g05, 
        webp: g05_webp,
        alt: "제네시스 차 외부 디자인 이미지", 
        href: "#", 
        pointEvt: "none", 
        loading: "lazy"
    },
]    